import '@/register-service-worker';
import router from '@/router';
import store from '@/store';
import Instance from './instance/index';
import App from './App.vue';

new Instance({
  router,
  store,
  render: (h: any) => h(App),
}).$mount('#app');
